import { render, staticRenderFns } from "./RiwayatPasien.vue?vue&type=template&id=8c59a7d2&scoped=true"
import script from "./RiwayatPasien.vue?vue&type=script&lang=js"
export * from "./RiwayatPasien.vue?vue&type=script&lang=js"
import style0 from "./RiwayatPasien.vue?vue&type=style&index=0&id=8c59a7d2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c59a7d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c59a7d2')) {
      api.createRecord('8c59a7d2', component.options)
    } else {
      api.reload('8c59a7d2', component.options)
    }
    module.hot.accept("./RiwayatPasien.vue?vue&type=template&id=8c59a7d2&scoped=true", function () {
      api.rerender('8c59a7d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/riwayat_pasien/RiwayatPasien.vue"
export default component.exports